import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLocationPin = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "29px",
	height: "29px",
	viewBox: "0 0 29 29",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "Icon / Location Pin" }),
		/* @__PURE__ */ _jsx("desc", { children: "Created with Sketch." }),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("path", {
			d: "M8.5,25 C6.13352034,25 1.79049035,19.821617 0.423521249,15.1569924 C0.148681887,14.321071 0,13.4278988 0,12.5 C0,7.80557963 3.80557963,4 8.5,4 C13.1944204,4 17,7.80557963 17,12.5 C17,13.4278988 16.8513181,14.321071 16.5764788,15.1569924 C15.2095097,19.821617 10.8664797,25 8.5,25 Z M15.6168364,14.875769 L15.6265075,14.844655 C15.8729407,14.0951307 16,13.3068068 16,12.5 C16,8.35786438 12.6421356,5 8.5,5 C4.35786438,5 1,8.35786438 1,12.5 C1,13.3068068 1.12705929,14.0951307 1.38316359,14.875769 C2.62264585,19.1053595 6.66947695,24 8.5,24 C10.330523,24 14.3773542,19.1053595 15.6168364,14.875769 Z M8.5,15 C9.88071187,15 11,13.8807119 11,12.5 C11,11.1192881 9.88071187,10 8.5,10 C7.11928813,10 6,11.1192881 6,12.5 C6,13.8807119 7.11928813,15 8.5,15 Z M8.5,16 C6.56700338,16 5,14.4329966 5,12.5 C5,10.5670034 6.56700338,9 8.5,9 C10.4329966,9 12,10.5670034 12,12.5 C12,14.4329966 10.4329966,16 8.5,16 Z",
			id: "path-location"
		}) }),
		/* @__PURE__ */ _jsxs("g", {
			id: "Icon-/-Location-Pin",
			stroke: "none",
			strokeWidth: 1,
			fill: "none",
			fillRule: "evenodd",
			children: [/* @__PURE__ */ _jsx("mask", {
				id: "mask-location",
				fill: "white",
				children: /* @__PURE__ */ _jsx("use", { xlinkHref: "#path-location" })
			}), /* @__PURE__ */ _jsx("use", {
				id: "icn-location-pin",
				fill: "currentColor",
				fillRule: "nonzero",
				xlinkHref: "#path-location"
			})]
		})
	]
});
export default SvgLocationPin;
